export default "__VITE_ASSET__238c2333__"